/** Inspect locally; never return a URL, title, slug, token or source id to telemetry. */
export type ShareSurface = "study_guide" | "deck" | "class" | "referral" | "app_page";
export function sharedAppSurface(text: string, origin: string): ShareSurface | undefined {
  const candidate = text.trim();
  // A clipboard of prose that happens to contain a link is not a share action.
  if (/\s/.test(candidate)) return undefined;
  try {
    const url = new URL(candidate.startsWith("jungleai.com") || candidate.startsWith("app.jungleai.com") ? `https://${candidate}` : candidate, origin);
    if (!["http:", "https:"].includes(url.protocol)) return undefined;
    if (url.origin !== origin && url.hostname !== "jungleai.com" && !url.hostname.endsWith(".jungleai.com")) return undefined;
    if (/^\/study-guide(?:\/|$)/.test(url.pathname)) return "study_guide";
    if (/^\/(review-decks?|deck-overview|learning-journey-overview)\//.test(url.pathname)) return "deck";
    if (/^\/class(?:\/|-)/.test(url.pathname)) return "class";
    if (["/", "/signup", "/login"].includes(url.pathname) && url.searchParams.has("r")) return "referral";
    // Do not treat a copied word, equation or arbitrary relative text as an app page.
    if (!/^https?:\/\//.test(candidate) && !candidate.startsWith("/")) return undefined;
    return "app_page";
  } catch { return undefined; }
}
